<template>
  <div>
    <md-field>
      <label for="manager">Manager</label>
      <md-select
        v-model="selectedManager"
        name="manager"
        id="manager"
        @md-selected="onChange()"
      >
        <md-option
          v-for="manager in managers"
          :key="manager.id"
          :value="manager.id"
        >
          {{ manager.full_name }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>
<script>
import optionsApi from "@/services/api/options";

export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      managers: [],
      selectedManager: this.value
    };
  },

  methods: {
    onChange: function() {
      this.$emit("input", this.selectedManager);
    }
  },

  beforeMount() {
    optionsApi.managers().then(resp => {
      this.managers = resp.data;
    });
  }
};
</script>
<style lang="scss" scoped></style>
